// extracted by mini-css-extract-plugin
export default {"tabsCard":"tabs_tabsCard__yDDWe"};